import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";

const ProjectTimelineChart = () => {
  const [chartData, setChartData] = useState({
    series: [],
    options: {
      chart: {
        type: "bar",
        height: 350,
        toolbar: { show: false },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "45%",
          endingShape: "rounded",
        },
      },
      dataLabels: {
        enabled: true,
        formatter: (val) => `${val}%`,
        style: {
          fontSize: "12px",
        },
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: [],
        labels: {
          style: {
            fontSize: "14px",
            fontFamily: "Cairo",
          },
        },
      },
      yaxis: {
        labels: {
          formatter: (val) => `${val}%`,
        },
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: (val) => `${val}%`,
        },
      },
      colors: ["#007bff", "#ffc107"], // blue & yellow
    },
  });

  useEffect(() => {
    fetch("https://promaster.areez.co/api/projects/compare_timeline_progress", {
        headers: {
            Authorization: `Bearer ${localStorage.getItem("user")}`,
            "Content-Type": "application/json"
          },
    })
      .then((res) => res.json())
      .then((data) => {
        const categories = data.map((item) => item.code);
        const achievementSeries = data.map((item) =>
          parseFloat(item.achievement_percentage_per_timeline.toFixed(2))
        );
        const scheduleSeries = data.map((item) =>
          parseFloat(item.schedule_indicator.toFixed(2))
        );

        setChartData((prev) => ({
          ...prev,
          series: [
            {
              name: "نسبة الإنجاز",
              data: achievementSeries,
            },
            {
              name: "المؤشر الزمني",
              data: scheduleSeries,
            },
          ],
          options: {
            ...prev.options,
            xaxis: {
              ...prev.options.xaxis,
              categories,
            },
          },
        }));
      })
      .catch((err) => {
        console.error("فشل في تحميل البيانات:", err);
      });
  }, []);

  return (
    <div className="card p-3">
      {/* <h5 className="mb-3 text-center">مقارنة نسب الإنجاز حسب الجدول الزمني</h5> */}
      <ReactApexChart
        options={chartData.options}
        series={chartData.series}
        type="bar"
        height={350}
      />
    </div>
  );
};

export default ProjectTimelineChart;
